module.exports = __webpack_public_path__ + "img/boss.7a6a462e.svg";